import apiClient from './client';
import {
  License,
  LicenseFilter,
  LicenseCreateRequest,
  LicenseUpdateRequest,
  LicenseListResponse,
} from '../types/license';

export const licenseApi = {
  getLicenses: async (filter: LicenseFilter) => {
    const response = await apiClient.get<LicenseListResponse>('/licenses', { params: filter });
    return response.data;
  },

  getLicense: async (id: string) => {
    const response = await apiClient.get<License>(`/licenses/${id}`);
    return response.data;
  },

  createLicense: async (data: LicenseCreateRequest) => {
    const response = await apiClient.post<License>('/licenses', data);
    return response.data;
  },

  updateLicense: async (id: string, data: LicenseUpdateRequest) => {
    const response = await apiClient.put<License>(`/licenses/${id}`, data);
    return response.data;
  },

  deleteLicense: async (id: string) => {
    await apiClient.delete(`/licenses/${id}`);
  },

  activateLicense: async (id: string): Promise<License> => {
    const response = await apiClient.post(`/licenses/${id}/activate`);
    return response.data;
  },

  deactivateLicense: async (id: string): Promise<License> => {
    const response = await apiClient.post(`/licenses/${id}/deactivate`);
    return response.data;
  },

  getUserLicenses: async (): Promise<LicenseListResponse> => {
    const response = await apiClient.get('/api/my-licenses');
    return response.data;
  },
};

// MyPageコンポーネント用のエクスポート
export const fetchUserLicenses = licenseApi.getUserLicenses; 